export default {
    meta: {
        title: '拓店任务类型变更记录',
        url: '/standardstore/tasklist',
        urlName: '标准版拓店-拓店任务',
    }
};
